export default __webpack_public_path__ + "static/media/BTS.b1b08347.jpg";